import React, { useState } from 'react'

/* LIBS */

import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

/* ICONS */
import { IconContext } from 'react-icons'

import HomeIcon from '@mui/icons-material/Home'
import InfoIcon from '@mui/icons-material/Info'
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { HiOutlineBars3 } from 'react-icons/hi2'

/* IMAGES */

import { logos } from '../Assets/Logo/logos'
import { FaFacebookSquare, FaInstagram, FaLinkedin } from 'react-icons/fa'

const NavBar = () => {
  const [openMenu, setOpenMenu] = useState(false)
  const menuOptions = [
    {
      text: 'Home',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <HomeIcon />
        </IconContext.Provider>
      ),
      link: ''
    },
    {
      text: 'Sobre Nós',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <InfoIcon />
        </IconContext.Provider>
      ),
      link: '#about'
    },
    {
      text: 'Serviços',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <MedicalServicesIcon />
        </IconContext.Provider>
      ),
      link: '#services'
    },
    {
      text: 'Contate-nos',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <PhoneRoundedIcon />
        </IconContext.Provider>
      ),
      link: '#contact'
    },
    {
      text: 'Agende Seu Exame',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <CalendarMonthIcon />
        </IconContext.Provider>
      ),
      url: 'https://asoonline.com.br/sistema/hub.asp'
    }
    // {
    //   text: "Acesse o Sistema",
    //   icon: (
    //     <IconContext.Provider value={{ size: "25px" }}>
    //       <GrSystem />
    //     </IconContext.Provider>
    //   ),
    //   link: "https://www.agendatecnica.com.br/v2/login.asp",
    // },
  ]

  // scroll top and reload window
  function handleHomeButton(e) {
    e.preventDefault()
    window.scrollTo(window.top)
    window.location.reload()
  }

  // scroll to section
  function scrollWindowToSection(section) {
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  return (
    <>
      <div className="top-menu">
        <div className="top-menu-social-media">
          {' '}
          <a
            href="https://www.facebook.com/Ammarhesconsultoria/"
            aria-label="https://www.facebook.com/Ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#0276a1' }}>
              <FaFacebookSquare />
            </IconContext.Provider>
          </a>
          <a
            href="https://www.linkedin.com/in/ammarhesconsultoria/"
            aria-label="https://www.linkedin.com/in/ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#0276a1' }}>
              <FaLinkedin />
            </IconContext.Provider>
          </a>
          <a
            href="https://www.instagram.com/ammarhesconsultoria/"
            aria-label="https://www.instagram.com/ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#0276a1' }}>
              <FaInstagram />
            </IconContext.Provider>
          </a>
        </div>

        <div className="top-menu-itens-container">
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">
                  CENTRAL DE AGENDAMENTO:
                </span>{' '}
                SEG - SEX : 07h- 19h
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">
                  HORÁRIO DE ATENDIMENTO DA CLÍNICA:
                </span>{' '}
                SEG - SEX : 07h30- 11h45
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">CONTATO: </span>
                <a href="mailto:comercial@ammarhes.com.br">
                  comercial@ammarhes.com.br
                </a>
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">LIGAR PARA: </span>
                <a href="tel:2122629752"> (21) 2262-9752</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <nav>
        <div className="nav-logo-container">
          <a href="" onClick={handleHomeButton}>
            <img src={logos.saude10} alt="Logo Saúde10" />
          </a>
        </div>
        <div className="navbar-links-container">
          <a href="" onClick={handleHomeButton}>
            Home
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#about')
              scrollWindowToSection(section)
            }}
          >
            Sobre Nós
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#services')
              scrollWindowToSection(section)
            }}
          >
            Serviços
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#contact')
              scrollWindowToSection(section)
            }}
          >
            Contate-nos
          </a>
          <a
            target="_blank"
            href="https://asoonline.com.br/sistema/hub.asp"
            rel="noreferrer"
            id="agenda"
          >
            Agende Seu Exame
          </a>
        </div>

        <div className="navbar-menu-container">
          <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
        </div>
        <Drawer
          open={openMenu}
          onClose={() => setOpenMenu(false)}
          anchor="right"
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={() => setOpenMenu(false)}
            onKeyDown={() => setOpenMenu(false)}
          >
            <List>
              {menuOptions.map(item => (
                <ListItem key={item.text} disablePadding>
                  <a
                    href={item.url ? item.url : ''}
                    target={item.url ? '_blank' : '_self'}
                    onClick={e => {
                      // se houver URL, mantém comportamento padrão.
                      if (item.url) {
                        return
                      }

                      // se houver link, cancelar comportamento padrão e redirecionar para a seção
                      e.preventDefault()
                      if (item.link) {
                        const section = document.querySelector(item.link)
                        scrollWindowToSection(section)
                        return
                      }
                      // atualizar página
                      handleHomeButton(e)
                    }}
                    className="navbar-menu-link"
                  >
                    <ListItemButton>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </a>
                </ListItem>
              ))}
            </List>
            <Divider />
            <div className="infos-mobile">
              <div className="text-top-menu-mobile">
                <div className="text-top-menu">
                  <p>
                    <span className="text-top-menu-span">
                      Central de agendamento:
                    </span>{' '}
                    Seg - Sex : 07h- 19h
                  </p>
                </div>
              </div>
              <div className="text-top-menu-mobile">
                <div className="text-top-menu">
                  <p>
                    <span className="text-top-menu-span">
                      Horário de atendimento da clínica:
                    </span>{' '}
                    Seg - Sex : 07h30- 11h45
                  </p>
                </div>
              </div>
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">Contato: </span> <br />
                  <a href="mailto:comercial@ammarhes.com.br">
                    comercial@ammarhes.com.br
                  </a>
                </p>
              </div>
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">Ligar para: </span>{' '}
                  <br />
                  <a href="tel:+552122629752">+55 (21) 2262-9752</a>
                </p>
              </div>
            </div>
          </Box>
        </Drawer>
      </nav>
    </>
  )
}

export default NavBar
